export default "<span [ngClass]=\"['status-label', getStatusClass(status)]\">\n    {{ getStatusLabel(status) }}\n</span>"